<template>
  <div class="statistics-container">
    <div class="video-container">
      <img class="video-poster"
        :src="require(`@/assets/images/matr1xFireIntro/${!isMobile ? '' : 'm_'}statistics_banner.png`)" alt="mask" />
    </div>
    <div class="statistics-main-container">
      <div class="scroll-text-wrap">
        <scroll-tranform :speed="1">
          <div class="scroll-text">Matr1x fire</div>
          <div class="scroll-text">Matr1x fire</div>
        </scroll-tranform>
        <scroll-tranform :speed="1" direction="right" v-if="isMobile">
          <div class="scroll-text">Matr1x fire</div>
          <div class="scroll-text">Matr1x fire</div>
        </scroll-tranform>
      </div>
      <div class="start-animation-wrap">
        <start-animation :canPlay="canPlay" @finish="() => moduleShow = true" />
      </div>
      <div class="modules-content" ref="modulesRef" v-if="moduleShow">
        <modules-statistic :titleData="titleData" />
      </div>
    </div>
  </div>
</template>

<script>
import scrollTranform from "@/components/scrollTranform";
import StartAnimation from "./components/startAnimation/index.vue";
import ModulesStatistic from "./components/modulesStatistic/index.vue";
import responsiveMixin from "@/mixins/responsive";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

export default {
  name: "Statistics",
  mixins: [responsiveMixin],
  components: { scrollTranform, StartAnimation, ModulesStatistic },
  props: {
    titleData: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      canPlay: false,
      moduleShow: false
    };
  },
  mounted() {
    this.initGsap();
  },
  methods: {
    initGsap() {
      this.$refs.modulesRef && gsap.set(".modules-content", { autoAlpha: 0 });
      const tl = gsap.timeline({
        scrollTrigger: {
          scroller: this.isMobile ? "#app" : "",
          trigger: ".start-animation-wrap",
          start: `bottom bottom`,
          end: "bottom bottom",
          markers: false,
          onUpdate: () => {
            this.canPlay = true;
          }
        }
      });
      tl.to(".modules-content", { autoAlpha: 1 }, "+=1")
    },
  },
  watch: {

  },
};
</script>

<style lang="scss" scoped>
@import "./index.scss";
</style>